import TablaTIR from "@/modules/dashboard/pages/tabla-tir/";
import Edit from "@/modules/dashboard/pages/tabla-tir/Edit";
import root from "@/modules/dashboard/pages/tabla-tir/root";

const tablaTIR = {
  path: "tabla-tir",
  name: "tabla-tir-root",
  redirect: "tabla-tir",
  component: root,
  children: [
    {
      path: "",
      name: "tabla-tir",
      component: TablaTIR, // Carga directa del componente
    },
    {
      path: ":etiqueta/edit",
      name: "tabla-tir-edit",
      component: Edit, // Carga directa del componente
    },
  ],
};

export default tablaTIR;
